import React from 'react';
import Highlighter from 'react-highlight-words';

import { Button } from '../../../components';
import { renderRecordValue } from '../../../utils';
import { USER_ROLES, USER_STATUSES } from '../../../constants/constants';
import { renderResetCredentialsButton } from '../../../components';

import styles from './index.module.css';
import { renderOrgStatus } from '../../../utils/helpers';
import { Popover } from 'antd';

const listPopoverContentStyle = {
  width: 280,
  maxWidth: 280,
  maxHeight: 200,
  overflowY: 'auto',
  overflowX: 'hidden',
  wordBreak: 'break-word',
  whiteSpace: 'normal',
  boxSizing: 'border-box',
};

const listPopoverOverlayStyle = {
  maxWidth: 300,
};

const renderListPopover = (text) => (
  <Popover
    content={<div style={listPopoverContentStyle}>{renderRecordValue(text)}</div>}
    placement="topLeft"
    overlayClassName={styles.overlay}
    overlayStyle={listPopoverOverlayStyle}
    classNames={{ root: styles.overlay }}
    styles={{ root: listPopoverOverlayStyle }}
    getPopupContainer={() => document.body}
  >
    <div>{renderRecordValue(text)}</div>
  </Popover>
);

export const renderColumns = (searchValue, highlighted) => [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    render: (text) => (
      <div className={styles.cellValue}>
        {searchValue && highlighted ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '# var(--ant-higlighter-color)', padding: 0 }}
            searchWords={[searchValue]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          renderRecordValue(text)
        )}
      </div>
    ),

    width: 150,
  },
  {
    title: 'Users',
    dataIndex: 'usersNumber',
    key: 'usersNumber',
    render: (text) => <div className={styles.cellValue}>{renderRecordValue(text)}</div>,
    width: 60,
  },
  {
    title: 'Drivers',
    dataIndex: 'drivers',
    key: 'drivers',
    render: (text) => <div className={styles.cellValue}>{renderRecordValue(text)}</div>,
    width: 60,
  },
  {
    title: 'State(s)',
    dataIndex: 'state',
    key: 'state',
    render: (text) => (
      <div className={styles.cellValue}>
        {searchValue && highlighted ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '# var(--ant-higlighter-color)', padding: 0 }}
            searchWords={[searchValue]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          renderRecordValue(text)
        )}
      </div>
    ),
    width: 180,
  },
  
  {
    title: 'Counties',
    dataIndex: 'counties',
    key: 'counties',
    render: (text) => (
      <div className={styles.colEllipsis}>
        {searchValue && highlighted ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '# var(--ant-higlighter-color)', padding: 0 }}
            searchWords={[searchValue]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          renderListPopover(text)
        )}
      </div>
    ),
    width: 180,
  },
  {
    title: 'Cities',
    dataIndex: 'cities',
    key: 'cities',
    render: (text) => (
      <div className={styles.colEllipsis}>
        {searchValue && highlighted ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '# var(--ant-higlighter-color)', padding: 0 }}
            searchWords={[searchValue]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          renderListPopover(text)
        )}
      </div>
    ),
    width: 80,
  },
  {
    title: 'Status',
    dataIndex: 'disabled',
    key: 'disabled',
    render: (text, record) => <div className={styles.cellValue}>{renderOrgStatus(text, record.adminStatus, false)}</div>,
    width: 90,
  },
  {
    title: '',
    key: 'buttons',
    dataIndex: 'buttons',
    render: (buttons) => <div className={styles.btnPanel}>{buttons.map((Component) => Component)}</div>,
    width: 440,
  },
];

export const transformData = ({
  data,
  handleManageOrganization,
  switchOrganizationStatus,
  handleSendPassword,
  handleResendInvitation,
  handleViewDashboard,
}) => {
  return data.map((value) => {
    const hasUsers = Boolean(value.usersNumber);

    let buttons;

    if (value.disabled) {
      buttons = [
        <div key={0} className={styles.inactiveButtons}>
          <Button
            myClassName={styles.navigationBtn}
            onClick={switchOrganizationStatus({ disabled: false, id: value.id })}>
            Activate Company
          </Button>
        </div>,
      ];
    } else {
      buttons = [
        ...(hasUsers ? [
          <div key="view-dashboard" className={styles.tableButton}>
            <Button
              disabled={value.adminStatus !== USER_STATUSES.ACTIVE}
              myClassName={styles.navigationBtn}
              onClick={handleViewDashboard({
                organizationId: value.id,
                role: USER_ROLES.TC_ADMIN,
                organizationName: value.name,
              })}>
              View Dashboard
            </Button>
          </div>,
        ] : []),
        ...(hasUsers ? [renderResetCredentialsButton({
          invited: value.adminStatus === USER_STATUSES.INVITED,
          value,
          handleSendPassword: handleSendPassword(value?.admin),
          handleResendInvitation: handleResendInvitation(value?.admin),
          resetButtonText: '(Send) Reset Password to Admin',
          resendButtonText: 'Resend Invitation to Admin',
        })] : []),
      ];

      buttons.push(
        <div key={buttons.length} className={styles.tableButton}>
          <Button myClassName={styles.navigationBtn} onClick={handleManageOrganization(value.id)}>
            Manage Company
          </Button>
        </div>
      );
    }

    return {
      key: value.id,
      name: value.name,
      usersNumber: value.usersNumber,
      state: value?.states?.join(', '),
      cities: value?.cities?.join(', '),
      counties: value?.counties?.join(', '),
      drivers: value.driversNumber || 0,
      disabled: value?.disabled,
      adminStatus: value?.adminStatus,
      buttons,
    };
  });
};
